export default "__VITE_ASSET__CrrtWCGP__"